import { render } from "./EmptyPortfolio.vue?vue&type=template&id=32eecf2b&scoped=true"
import script from "./EmptyPortfolio.vue?vue&type=script&lang=js"
export * from "./EmptyPortfolio.vue?vue&type=script&lang=js"

import "./EmptyPortfolio.vue?vue&type=style&index=0&id=32eecf2b&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32eecf2b"]])

export default __exports__